<template>
  <v-layout>
    <v-flex v-if="reportsPending">
      <v-flex>
        Getting task report...
        <v-progress-linear indeterminate></v-progress-linear>
      </v-flex>
    </v-flex>
    <v-flex v-else>
      <v-layout column full-width>
        <v-text-field
          label="Task Title or Description..."
          v-model="textSearch"
          clearable
          @keyup.enter="reGetRecords"
        />
      </v-layout>

      <v-layout column full-width>
        <v-layout row align-center>
          <v-flex class="mr-2">
            <v-autocomplete
              label="Assigned Employees"
              :items="employeeFilters"
              item-text="name"
              item-value="id"
              v-model="assignedUsers"
              :loading="employeesLoading"
              :disabled="employeesLoading"
              multiple
              clearable
              return-object
            />
          </v-flex>
          <v-flex>
            <v-autocomplete
              label="Assigned Managers"
              :items="managerFilters"
              item-text="name"
              item-value="id"
              v-model="assignedUsers"
              :loading="managersLoading"
              :disabled="managersLoading"
              multiple
              clearable
              return-object
            />
          </v-flex>
        </v-layout>

        <v-layout row align-center>
          <template>
            <v-flex>
              <v-menu
                ref="createdStartDateMenu"
                v-model="createdStartDateMenu"
                :close-on-content-click="false"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <template slot="activator" slot-scope="{ on }">
                  <v-text-field
                    label="Created After"
                    format="dddd, MM DD YYYY"
                    @change="value => (createdStartDate = value)"
                    :value="dateFormatted(createdStartDate)"
                    prepend-icon="event"
                    readonly
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  :show-current="createdEndDate"
                  v-model="createdStartDate"
                  @input="createdStartDateMenu = false"
                  no-title
                  scrollable
                >
                </v-date-picker>
              </v-menu>
            </v-flex>
          </template>
          <template>
            <v-flex>
              <v-menu
                ref="createdEndDateMenu"
                v-model="createdEndDateMenu"
                :close-on-content-click="false"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <template slot="activator" slot-scope="{ on }">
                  <v-text-field
                    label="Created Before"
                    format="dddd, MM DD YYYY"
                    @change="value => (createdEndDate = value)"
                    :value="dateFormatted(createdEndDate)"
                    prepend-icon="event"
                    readonly
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  :show-current="createdStartDate"
                  v-model="createdEndDate"
                  @input="createdEndDateMenu = false"
                  no-title
                  scrollable
                >
                </v-date-picker>
              </v-menu>
            </v-flex>
          </template>
        </v-layout>

        <v-layout row align-center>
          <v-flex shrink>
            <v-switch v-model="filterDue" label="Filter by Due" />
          </v-flex>
          <v-flex grow v-if="filterDue">
            <v-layout row>
              <template>
                <v-flex>
                  <v-menu
                    ref="dueStartDateMenu"
                    v-model="dueStartDateMenu"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                  >
                    <template slot="activator" slot-scope="{ on }">
                      <v-text-field
                        label="Due After"
                        format="dddd, MM DD YYYY"
                        @change="value => (dueStartDate = value)"
                        :value="dateFormatted(dueStartDate)"
                        prepend-icon="event"
                        readonly
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      :show-current="dueEndDate"
                      v-model="dueStartDate"
                      @input="dueStartDateMenu = false"
                      no-title
                      scrollable
                    >
                    </v-date-picker>
                  </v-menu>
                </v-flex>
              </template>
              <template>
                <v-flex>
                  <v-menu
                    ref="dueEndDateMenu"
                    v-model="dueEndDateMenu"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                  >
                    <template slot="activator" slot-scope="{ on }">
                      <v-text-field
                        label="Due Before"
                        format="dddd, MM DD YYYY"
                        @change="value => (dueEndDate = value)"
                        :value="dateFormatted(dueEndDate)"
                        prepend-icon="event"
                        readonly
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      :show-current="dueStartDate"
                      v-model="dueEndDate"
                      @input="dueEndDateMenu = false"
                      no-title
                      scrollable
                    >
                    </v-date-picker>
                  </v-menu>
                </v-flex>
              </template>
            </v-layout>
          </v-flex>
        </v-layout>

        <div v-if="doneOnly">
          <v-layout row align-center>
            <template>
              <v-flex>
                <v-autocomplete
                  label="Done By Users"
                  :items="allUserFilter"
                  item-text="display_name"
                  item-value="id"
                  v-model="doneByUsers"
                  :loading="employeesLoading"
                  :disabled="employeesLoading"
                  multiple
                  clearable
                  return-object
                />
              </v-flex>
              <v-flex>
                <v-menu
                  ref="doneStartDateMenu"
                  v-model="doneStartDateMenu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <template slot="activator" slot-scope="{ on }">
                    <v-text-field
                      label="Done After"
                      format="dddd, MM DD YYYY"
                      @change="value => (doneStartDate = value)"
                      :value="dateFormatted(doneStartDate)"
                      prepend-icon="event"
                      readonly
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    :show-current="doneEndDate"
                    v-model="doneStartDate"
                    @input="doneStartDateMenu = false"
                    no-title
                    scrollable
                  >
                  </v-date-picker>
                </v-menu>
              </v-flex>
            </template>
            <template>
              <v-flex>
                <v-menu
                  ref="doneEndDateMenu"
                  v-model="doneEndDateMenu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <template slot="activator" slot-scope="{ on }">
                    <v-text-field
                      label="Done Before"
                      format="dddd, MM DD YYYY"
                      @change="value => (doneEndDate = value)"
                      :value="dateFormatted(doneEndDate)"
                      prepend-icon="event"
                      readonly
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    :show-current="doneStartDate"
                    v-model="doneEndDate"
                    @input="doneEndDateMenu = false"
                    no-title
                    scrollable
                  >
                  </v-date-picker>
                </v-menu>
              </v-flex>
            </template>
          </v-layout>
          <v-layout row align-center>
            <v-switch
              v-model="filterDoneEarly"
              label="Done on Time"
              hint="Only shows tasks with due dates"
              persistent-hint
            />
            <v-switch
              v-model="filterDoneLate"
              label="Done Late"
              hint="Only shows tasks with due dates"
              persistent-hint
            />
          </v-layout>
        </div>

        <v-layout row align-center>
          <v-flex class="mr-2" xs3 v-if="showAutomated">
            <v-autocomplete
              label="Only Show Automed Type..."
              :items="['expire', 'ongoing']"
              v-model="showAutomatedType"
              clearable
            />
          </v-flex>
        </v-layout>

        <v-layout row align-center>
          <v-switch v-model="doneOnly" label="Only Show Done" />
          <v-switch v-model="priorityOnly" label="Only Show Priority" />
          <v-switch v-model="showAutomated" label="Show Automated" />
          <v-btn @click="reGetRecords" color="primary">
            Update
          </v-btn>
        </v-layout>

        <v-data-table
          :items="report"
          :headers="headers"
          :pagination.sync="defaultSort"
          item-key="worksite_id"
          class="elevation-1"
        >
          <template slot="items" slot-scope="{ item }">
            <tr>
              <td>
                <v-layout row>
                  <v-flex v-if="item.done">
                    <v-tooltip right>
                      <v-icon slot="activator" :color="doneColor(item)"
                        >check_circle</v-icon
                      >
                      <span>{{ doneTooltip(item) }}</span>
                    </v-tooltip>
                  </v-flex>
                  <v-flex v-else>
                    <v-tooltip right>
                      <v-icon slot="activator" :color="undoneColor(item)"
                        >radio_button_unchecked</v-icon
                      >
                      <span>{{ undoneTooltip(item) }}</span>
                    </v-tooltip>
                  </v-flex>
                  <v-flex>
                    <v-tooltip right>
                      <v-icon slot="activator" color="red" v-if="item.priority">
                        priority_high
                      </v-icon>
                      <span>Priority</span>
                    </v-tooltip>
                  </v-flex>
                </v-layout>
              </td>
              <td>
                {{ item.task }}
                <span v-if="item.details != ''">
                  <v-icon small @click="showNotes(item.details)">
                    note
                  </v-icon>
                </span>
              </td>
              <td>
                <!-- {{ item.assigned_user.id }} -->
                <router-link
                  :to="{
                    name: 'managedTodoLists',
                    query: { userID: item.assigned_user.id }
                  }"
                >
                  {{ item.assigned_user.first_name }}
                  {{ item.assigned_user.last_name }}
                </router-link>
              </td>
              <td>
                {{ item.created_at | moment("MMMM DD, YYYY, h:mma") }}
              </td>
              <td>
                {{ item.due_on | moment("MMMM DD, YYYY") }}
              </td>
              <td>
                {{ item.done_on | moment("MMMM DD, YYYY, h:mma") }}
              </td>
              <td>
                <!-- {{ item.done_by_id }} -->
                <div v-if="item.done_by">
                  {{ item.done_by.first_name }}
                  {{ item.done_by.last_name }}
                </div>
              </td>
              <td v-if="showAutomated">
                <v-tooltip left>
                  <v-chip
                    slot="activator"
                    icon
                    v-if="item.task_type == 'ongoing'"
                  >
                    <v-icon small>
                      repeat
                    </v-icon>
                  </v-chip>
                  <span>Automated task: Ongoing</span>
                </v-tooltip>
                <v-tooltip left>
                  <v-chip
                    slot="activator"
                    icon
                    v-if="item.task_type == 'expire'"
                  >
                    <v-icon small>
                      update
                    </v-icon>
                  </v-chip>
                  <span>Automated task: Expiration</span>
                </v-tooltip>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-layout>
    </v-flex>

    <v-dialog maxWidth="300" v-model="showingNotes">
      <v-card>
        <v-card-text>{{ shownNotes }}</v-card-text>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import { ExportToCsv } from "export-to-csv";
import reportsApi from "@/api/reports.js";
import collectionApi from "@/api/collections.js";

export default {
  components: {},
  computed: {
    ...mapState("userAuth", ["user"]),
    //computedOffset: function () {
    //  return this.limit * (this.page - 1)
    //},
    //pageLength: function () {
    //  return Math.ceil(this.queryTotal / this.limit)
    //},
    formattedQuery: function() {
      return {
        createdStartDate: this.createdStartDate,
        createdEndDate: this.createdEndDate,
        doneStartDate: this.doneStartDate,
        doneEndDate: this.doneEndDate,
        doneOnly: this.doneOnly,
        doneByUserIDs: this.doneByUserIDs,
        priorityOnly: this.priorityOnly,
        showAutomated: this.showAutomated,
        assignedUserIDs: this.assignedUserIDs,
        showAutomatedType: this.showAutomatedType,
        textSearch: this.textSearch,
        filterDue: this.filterDue,
        dueStartDate: this.dueStartDate,
        dueEndDate: this.dueEndDate,
        filterDoneLate: this.filterDoneLate,
        filterDoneEarly: this.filterDoneEarly
        //limit: this.limit,
        //offset: this.computedOffset,
        //page: this.page,
      };
    },
    assignedUserIDs() {
      return this.assignedUsers.map(u => u.id);
    },
    doneByUserIDs() {
      return this.doneByUsers.map(u => u.id);
    },
    headers() {
      var headers = [
        {
          text: "Done?",
          value: "done",
          sortable: true,
          width: "5%",
          align: "left"
        },
        { text: "Task", value: "task", sortable: true, width: "20%" },
        { text: "User", value: "last_name", sortable: true },
        { text: "Created", value: "created_at", sortable: true },
        { text: "Due", value: "due_on", sortable: true },
        { text: "Done On", value: "done_on", sortable: true },
        { text: "Done By", value: "done_by_id", sortable: true }
      ];
      if (this.showAutomated) {
        headers.push({ text: "Task Type", value: "task_type", sortable: true });
      }
      return headers;
    }
  },
  created() {
    this.setUp();
  },
  watch: {
    //'page': {
    //  handler(value) {
    //    if (value != this.$route.query.page) {
    //      this.reGetRecords()
    //    } else {
    //    }
    //  }
    //}
  },
  data: function() {
    return {
      limit: 40,
      page: 1,

      employeeFilters: [],
      employeesLoading: false,
      managersLoading: false,
      assignedUsers: [],
      employeeFilters: [],
      managerFilters: [],
      showAutomatedType: "",

      createdStartDateMenu: false,
      createdEndDateMenu: false,
      createdStartDate: "",
      createdStartDate: this.$moment()
        .subtract(1, "year")
        .format("YYYY-MM-DD"),
      createdEndDate: "",
      createdEndDate: this.$moment().format("YYYY-MM-DD"),

      doneStartDateMenu: false,
      doneEndDateMenu: false,
      doneStartDate: "",
      doneStartDate: this.$moment()
        .subtract(4, "weeks")
        .format("YYYY-MM-DD"),
      doneEndDate: "",
      doneEndDate: this.$moment().format("YYYY-MM-DD"),
      doneByUsers: [],
      filterDoneEarly: false,
      filterDoneLate: false,

      filterDue: false,
      dueStartDateMenu: false,
      dueEndDateMenu: false,
      dueStartDate: "",
      dueStartDate: this.$moment()
        .subtract(4, "weeks")
        .format("YYYY-MM-DD"),
      dueEndDate: "",
      dueEndDate: this.$moment()
        .add(4, "weeks")
        .format("YYYY-MM-DD"),

      textSearch: "",

      doneOnly: false,
      priorityOnly: false,
      showAutomated: false,

      showingNotes: false,
      shownNotes: "",

      reportsPending: true,
      loadingCsv: false,
      report: [],
      defaultSort: {
        sortBy: "created_at",
        descending: "false",
        rowsPerPage: 20 //all
      }
    };
  },

  methods: {
    setUp: function() {
      this.createdStartDate =
        this.$route.query.createdStartDate || this.createdStartDate;
      this.createdEndDate =
        this.$route.query.createdEndDate || this.createdEndDate;
      this.doneStartDate =
        this.$route.query.doneStartDate || this.doneStartDate;
      this.doneEndDate = this.$route.query.doneEndDate || this.doneEndDate;
      // this.assignedUserIDs = this.$route.query.doneEndDate || this.doneEndDate;

      this.employeesLoading = true;
      collectionApi.getEmployees(employees => {
        this.employeeFilters = employees;
        this.employeesLoading = false;
      });

      this.managersLoading = true;
      collectionApi.getManagersList({ includeBoh: true }, managers => {
        this.managerFilters = managers;
        this.managersLoading = false;
      });

      this.allUsersLoading = true;
      collectionApi.getAllTasksUsers(users => {
        this.allUserFilter = users;
        this.allUsersLoading = false;
      });

      this.getReports();
    },

    showNotes(notes) {
      this.showingNotes = true;
      this.shownNotes = notes;
    },

    closeNotes() {
      this.showingNotes = false;
      this.shownNotes = "";
    },

    undoneColor(task) {
      if (!task.done && this.$moment(task.due_on).isBefore(this.$moment())) {
        return "red";
      }
      return "default";
    },
    undoneTooltip(task) {
      if (!task.done && this.$moment(task.due_on).isBefore(this.$moment())) {
        return "Overdue";
      }
      return "Not yet due";
    },

    doneColor(task) {
      if (this.noDueDate(task)) {
        return "default";
      }
      if (this.doneLate(task)) {
        return "red";
      }
      if (this.doneEarly(task)) {
        return "green";
      }
    },
    doneTooltip(task) {
      if (this.noDueDate(task)) {
        return "No due date";
      }
      if (this.doneLate(task)) {
        return "Done after due date";
      }
      if (this.doneEarly(task)) {
        return "Done before due date";
      }
    },

    noDueDate(task) {
      return !task.due_on;
    },
    doneLate(task) {
      if (this.$moment(task.due_on).isBefore(this.$moment(task.done_on))) {
        return true;
      }
      return false;
    },
    doneEarly(task) {
      if (this.$moment(task.due_on).isAfter(this.$moment(task.done_on))) {
        return true;
      }
      return false;
    },

    // TODO:
    // generateCsv: function(report) {
    //   const options = {
    //     fieldSeparator: ',',
    //     quoteStrings: '"',
    //     decimalSeparator: '.',
    //     showLabels: true,
    //     showTitle: false,
    //     filename: `billing-report_${this.$moment(this.createdStartDate).format(
    //       'YYYY-MM-DD',
    //     )}--${this.$moment(this.createdEndDate).format('YYYY-MM-DD')}`,
    //     useTextFile: false,
    //     useBom: true,
    //     useKeysAsHeaders: true,
    //   };

    //   const exportedFormat = report.map(s => {
    //     const row = {};

    //     row['Parent client'] = s.client_business;

    //     row['Client location'] = s.location;

    //     row['Service'] = 'Staffing';

    //     row['Position'] = s.position;

    //     row['Dif'] = s.dif;

    //     row['Employee'] = s.worker;

    //     row['Date'] = this.$moment(s.start_datetime).format('YYYY-MM-DD');

    //     row['Quantity'] = s.hours_worked;

    //     row['Client-added bonus'] = s.bonuses
    //       .filter(b => b.type == 'Client-added')
    //       .map(b => b.amount);
    //     row['Travel bonus'] = s.bonuses
    //       .filter(b => b.type == 'Travel')
    //       .map(b => b.amount);
    //     row['Call-in bonus'] = s.bonuses
    //       .filter(b => b.type == 'Call-in')
    //       .map(b => b.amount);

    //     // TODO: Cancellation columns

    //     return row;
    //   });

    //   const csvExporter = new ExportToCsv(options);
    //   csvExporter.generateCsv(exportedFormat);
    //   this.loadingCsv = false;
    // },

    // csvExport: function() {
    //   this.loadingCsv = true;
    //   reportsApi.getTaskReport({
    //       createdStartDate: this.createdStartDate,
    //       createdEndDate: this.createdEndDate,
    //     })
    //     .then(report => {
    //       this.generateCsv(report);
    //     })
    //     .catch(err => {
    //       console.log(err);
    //     })
    //     .finally(r => {
    //       this.loadingCsv = false;
    //     });
    // },

    dateFormatted: function(date) {
      return date ? this.$moment(date).format("dddd, MMMM D, YYYY") : "";
    },

    getReports: function() {
      this.reportsPending = true;
      reportsApi.getTaskReport(
        this.formattedQuery,
        response => {
          this.report = response.report;
          this.reportsPending = false;
        },
        err => {
          console.log(err);
        }
      );
    },
    reGetRecords: function() {
      this.getReports();
    }
  }
};
</script>

<style scoped></style>
